import { render, staticRenderFns } from "./BasicNoteCardNew.vue?vue&type=template&id=b8c2b622&scoped=true"
import script from "./BasicNoteCardNew.vue?vue&type=script&lang=ts"
export * from "./BasicNoteCardNew.vue?vue&type=script&lang=ts"
import style0 from "./BasicNoteCardNew.vue?vue&type=style&index=0&id=b8c2b622&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c2b622",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8c2b622')) {
      api.createRecord('b8c2b622', component.options)
    } else {
      api.reload('b8c2b622', component.options)
    }
    module.hot.accept("./BasicNoteCardNew.vue?vue&type=template&id=b8c2b622&scoped=true", function () {
      api.rerender('b8c2b622', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/BasicNoteCardNew.vue"
export default component.exports